// Mark: used in V2
import classNames from "classnames"
import React from "react"

type Props = {
  className?: string
  width?: number
  height?: number
  opacity?: number
  showBorder?: boolean
  checkmarkClassName?: string
  borderClassName?: string
}

const CircleCheckIcon = ({
  className,
  width = 20,
  height = 20,
  opacity = 0.3,
  showBorder = true,
  checkmarkClassName = "stroke-current",
  borderClassName = "stroke-current",
}: Props) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <path
        opacity={`${opacity}`}
        clipRule="evenodd"
        d="M23 13c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C3 7.476 7.478 3 13 3c5.523 0 10 4.476 10 10Z"
        strokeWidth="1.661"
        className={classNames(showBorder ? borderClassName : "stroke-none")}
      />
      <path
        d="m9.354 13 2.806 2.806 5.102-5.102"
        strokeWidth="1.661"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={checkmarkClassName}
      />
    </svg>
  )
}

export default CircleCheckIcon
